var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "24px",
    viewBox: "0 0 21 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6C777181-F355-4C3F-9A24-A53C784F319C@1,5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.05263158,0 C2.26214021,0 0,2.26214021 0,5.05263158 L0,18.9473684 C0,21.7378598 2.26214021,24 5.05263158,24 L15.1578947,24 C17.9483861,24 20.2105263,21.7378598 20.2105263,18.9473684 L20.2105263,8.59914356 C20.2105263,7.18199421 19.6153792,5.82998661 18.5702511,4.8728975 L14.697509,1.32638552 C13.7658653,0.473221154 12.548422,0 11.2851526,0 M6.4962406,20.2105263 C5.69895735,20.2105263 5.05263158,19.6449913 5.05263158,18.9473684 C5.05263158,18.2497456 5.69895735,17.6842105 6.4962406,17.6842105 L13.7142857,17.6842105 C14.511569,17.6842105 15.1578947,18.2497456 15.1578947,18.9473684 C15.1578947,19.6449913 14.511569,20.2105263 13.7142857,20.2105263 M6.4962406,15.1578947 C5.69895735,15.1578947 5.05263158,14.5923597 5.05263158,13.8947368 C5.05263158,13.197114 5.69895735,12.6315789 6.4962406,12.6315789 L13.7142857,12.6315789 C14.511569,12.6315789 15.1578947,13.197114 15.1578947,13.8947368 C15.1578947,14.5923597 14.511569,15.1578947 13.7142857,15.1578947 M6.4962406,10.1052632 C5.69895735,10.1052632 5.05263158,9.53972811 5.05263158,8.84210526 C5.05263158,8.14448242 5.69895735,7.57894737 6.4962406,7.57894737 L13.7142857,7.57894737 C14.511569,7.57894737 15.1578947,8.14448242 15.1578947,8.84210526 C15.1578947,9.53972811 14.511569,10.1052632 13.7142857,10.1052632",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "08---Consultas-Online",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MY-D-08-01-18-Detalhe-consulta-marcada",
    transform: "translate(-755.000000, -985.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "modal",
    transform: "translate(150.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(58.000000, 219.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 691.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buttons/menu_internal-copy-2",
    transform: "translate(524.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cards/close_icon-copy",
    transform: "translate(23.672217, 15.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Color",
    fill: "#000000",
    xlinkHref: "#path-1"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.ed666cf4f7cd7a8bd1b157fb38f39879.svg";
export { ForwardRef as ReactComponent };